module.exports = require("https");


//////////////////
// WEBPACK FOOTER
// external "https"
// module id = https
// module chunks = 5